import { styled } from "styled-components";
import Moment from 'react-moment';

const FieldsetBody = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;

  .time {
    display: block;
    text-align: center;
    
    color: #A9A9A9;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  
  @media (max-width: 991px) {
    margin-bottom: 10px;

    padding: 5px;
  }  
`;

const Wrapper = styled.div`
  border-top: 1px solid #E0E0E0;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  
  p {
    display: inline-flex;
    margin-top: -20px;
    border-left: 16px solid #FFF;
    border-right: 16px solid #FFF;
  }
  
  span {
    height: 38px;
    padding: 8px 20px;
    display: inline-table;
    
    border-radius: 8px;
    background: #F5F5F5;
    
    color: #000;
    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
  }
  
  @media (max-width: 991px) {
    width: 100%;
    p {
      margin-bottom: 10px;
    }
  } 
`;

const Fieldset = ({ title, time }) => {
  return <FieldsetBody>
    <Wrapper><p><span>{title}</span></p></Wrapper>
    {time && <span className='time'><Moment format="ddd, MMM DD, hh:mm a">{time}</Moment></span>}
  </FieldsetBody>
};

export default Fieldset;
